import { Component, OnInit } from '@angular/core';

import { FoundDocument, REASONS } from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

/** Asks why one or more documents are irrelevant. Rendered only while `df.excludeIds` is set. */
@Component({
    selector: 'df-exclude-modal',
    templateUrl: './df-exclude-modal.component.html',
    styleUrls: ['./df-exclude-modal.component.scss'],
    standalone: false
})
export class DfExcludeModalComponent implements OnInit {
    public readonly reasons = REASONS;
    public ids: string[] = [];
    public reason: string = '';
    public why: string = '';

    constructor(public df: DocumentFinderService) {}

    public ngOnInit(): void {
        this.ids = [...(this.df.excludeIds ?? [])];
        const first = this.ids[0];
        this.reason = (first && this.df.reasons[first]) || '';
        this.why = (first && this.df.whys[first]) || '';
    }

    public get firstDoc(): FoundDocument | undefined {
        return this.df.documents.find(d => d.id === this.ids[0]);
    }

    public get isBulk(): boolean {
        return this.ids.length > 1;
    }

    /** Enabled once a reason is picked or a note is typed. */
    public get canSave(): boolean {
        return !!this.reason || !!this.why.trim();
    }

    public pick(r: string): void {
        this.reason = r;
    }

    public save(): void {
        if (!this.canSave || !this.ids.length) { return; }
        const reason = this.reason || 'Other';
        this.df.exclude(this.ids, reason, this.why.trim());
        const n = this.ids.length;
        this.df.selection.clear();
        this.df.closeAll();
        this.df.toast((n > 1 ? `${n} documents marked irrelevant · ` : 'Marked irrelevant · ') + reason);
    }

    public cancel(): void {
        this.df.closeAll();
    }
}
